import React from 'react'
import {SvgPainter} from '../../lib/painter/svg-painter'
import {type BackgroundLayout, type BgColor} from '../../lib/lvs-foni'
import {paintSign, type ArrowPlacement} from '../../lib/sign-renderer'

export interface SignBodyProps {
    readonly layout: BackgroundLayout
    readonly bgColor: BgColor
    readonly strike: boolean
    /** Optional arrow placement (sign 705). Forwarded to paintSign. */
    readonly arrow?: ArrowPlacement
    /** Unique id suffix so multiple instances on one page don't collide. */
    readonly idSuffix: string
}

/**
 * Clean sign render: background + auto rows + optional 0.4h red
 * diagonal strike (§9.20) + optional arrow (sign 705). Driven by
 * paintSign — the single source of truth for how a sign looks.
 * Consumed by FoniCanvas (annotated preview).
 */
export function SignBody({
    layout,
    bgColor,
    strike,
    arrow,
    idSuffix
}: SignBodyProps): React.ReactElement {
    const p = new SvgPainter('screen', idSuffix)
    paintSign(p, layout, bgColor, strike, arrow)
    return <g>{p.children()}</g>
}
